<template>
	<div>
		<div v-if="$route.name === 'job-evaluation-processes'">
			<div class="tw-flex tw--mx-2">
				<div class='tw-w-8/12 tw-px-2 tw-flex'>
					<div class="tw-flex tw--mx-2 tw-items-center tw-justify-center tw-w-full">
						<div class="tw-w-1/4 tw-px-2" v-for="(supply) in localProcees">
							<supply-card
								:supply='supply'
								:enabled="supply.enabled"
								:selected="supply.id === selectedSupply.id"
								:completed="supply.completed"
								@click="selectSupply"
								@goClick="onNewClicked"
							/>
						</div>
					</div>
				</div>
				<div class='tw-w-4/12 tw-px-2 supply-description-wrapper'>
					<supply-card-detail
						:rotate="rotate"
						:selected-supply="selectedSupply"
					/>
				</div>
			</div>
		</div>
		<div v-else>
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
	import supplyCard from '@/modules/job-evaluation/components/supplies/supply-card';
	import supplyCardDetail from '@/modules/job-evaluation/components/supplies/supply-card-detail';
	import { head, length, pathOr, pipe } from 'ramda';
	import { mapState } from 'vuex';
	import { parseProcesses } from '@/modules/job-evaluation/utils/processes/processes';

	function data() {
		return {
			localProcees: [],
			rotate: false,
			selectedSupply: {},
		};
	}

	export default {
		name: 'page-job-evaluation-processes',
		data,
		components: { supplyCard, supplyCardDetail },
		beforeMount() {
			this.$store.dispatch('jobEvaluation/loadJobEvaluationConfig');
		},
		methods: {
			selectSupply(supply) {
				if (this.selectedSupply.id === supply.id) return;
				this.selectedSupply = supply;
				this.rotate = !this.rotate;
			},
			onNewClicked(selectedSupply) {
				this.goTo(selectedSupply.goTo);
			},
		},
		computed: {
			...mapState('jobEvaluation', {
				process: pipe(
					pathOr([], ['mainData', 'config', 'stages', 1, 'details']),
					parseProcesses,
				),
			}),
		},
		watch: {
			process: {
				handler(value) {
					if (length(value) > 1) {
						this.localProcees = value;
						this.selectedSupply = head(this.localProcees) || {};
					}
				},
				immediate: true,
			},
		},
	};
</script>

<style lang="scss" scoped>
.supply-description-wrapper {
	min-height: 600px;
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/pages/supplies/page-job-evaluation-processes.vue